<ng-container [formGroup]="formParent">
  <label [for]="id" [class.required]="required && !hideRequiredLabel">{{
    label | translate
  }}</label>
  <div class="form-field-container">
    <mat-select
      [formControlName]="name"
      [(ngModel)]="value"
      [id]="id"
      [attr.readonly]="readonly"
      [attr.aria-required]="required ? true : null"
      [multiple]="multiple"
      class="easy-select"
      [placeholder]="placeholder | translate"
      floatPlaceholder="never"
      #easySelect
      (keydown)="onSelectField($event)"
    >
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node
          class="easy-select-tree-node"
          *matTreeNodeDef="let node"
          [matTooltip]="disabledMatTooltip | translate"
          [matTooltipDisabled]="!node.value['disabled']"
        >
          <mat-option
            [value]="node.value[valueAttribute]"
            [disabled]="node.value['disabled']"
            [class.highlight]="node.value.highlight"
          >
            {{ node.name | translate }}
          </mat-option>
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node
          class="easy-select-tree-node"
          *matTreeNodeDef="let node; when: hasChild"
        >
          <div
            class="group-option"
            [matTooltip]="disabledMatTooltip | translate"
            [matTooltipDisabled]="!node.value['disabled']"
          >
            <mat-checkbox
              class="group-option-label easy-checkbox"
              (change)="groupChange($event, node)"
              [checked]="isGroupChecked(node)"
              [disabled]="node.value['disabled']"
              *ngIf="node.value[valueAttribute]; else groupTitle"
            >
              <span class="group-option-label">
                {{ node.name | translate }}
              </span>
            </mat-checkbox>
            <ng-template #groupTitle>
              <span class="group-option-label">
                {{ node.name | translate }}
              </span>
            </ng-template>
            <button type="button" mat-icon-button matTreeNodeToggle>
              <mat-icon class="mat-icon-rtl-mirror">
                {{
                  treeControl.isExpanded(node) ? "expand_more" : "chevron_right"
                }}
              </mat-icon>
            </button>
          </div>
        </mat-tree-node>
      </mat-tree>
    </mat-select>
  </div>
  <ng-container *ngIf="showErrorMessages">
    <mat-error
      id="{{ id }}-required-error"
      *ngIf="ngControl.touched && ngControl?.hasError('required')"
    >
      {{ "REQUIRED" | translate }}
    </mat-error>
  </ng-container>
</ng-container>

<mat-chip-listbox
  class="easy-chiplist mt-3"
  *ngIf="showSelectedLabels && multiple && value?.length"
>
  <mat-chip
    *ngFor="let item of value"
    [disabled]="ngControl.disabled"
    [attr.aria-readonly]="readonly"
    (removed)="removeSelected(item)"
  >
    {{ item[labelAttribute] ?? item }}
    <button matChipRemove *ngIf="!ngControl.disabled">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-chip>
</mat-chip-listbox>
